import React, { useState } from 'react';
import { AxisTickProps } from '@nivo/axes';
import { Flex, Image } from '@tapresearch/ui/components';

import { TapAnswer } from 'app/javascript/bundles/insights_platform/api';

import { OpacityTransitionBox } from '../../../../../shared/OpacityTransitionBox';
import { AnimatePresence } from 'framer-motion';

export interface ImageTickProps extends AxisTickProps<string> {
  answersById: Record<string, TapAnswer['attributes']>;
}

export function ImageTick({ x, y, value, answersById }: ImageTickProps) {
  const [isHovering, setIsHovering] = useState(false);

  const size = 32;

  return (
    <g transform={`translate(${x - 21},${y})`}>
      <foreignObject
        width={size}
        height={size}
        x={-11}
        y={-18}
        style={{ overflow: 'visible' }}
      >
        <Flex
          zIndex="10"
          justifyContent="space-around"
          alignItems="center"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          w="100%"
          h="100%"
          position="relative"
          overflow="visible"
        >
          <Image w="100%" src={answersById[value].image.url} alt={value} />
          <AnimatePresence>
            {isHovering && (
              <OpacityTransitionBox
                top="44px"
                right="0px"
                h="180px"
                w="180px"
                bgColor="white"
                position="absolute"
                duration={1}
              >
                <Image
                  w="100%"
                  src={answersById[value].image.url}
                  alt={value}
                />
              </OpacityTransitionBox>
            )}
          </AnimatePresence>
        </Flex>
      </foreignObject>
    </g>
  );
}

export function getImageTick(
  answersById: Record<string, TapAnswer['attributes']>
) {
  // eslint-disable-next-line react/display-name
  return (props: AxisTickProps<string>) => (
    <ImageTick answersById={answersById} {...props} />
  );
}
